// FILE: src/components/admin_pages/loginModals/useGoogleLoginHandlerAdmin.js
import { jwtDecode } from "jwt-decode";
import api from "../../axios/axiosInstance";
import { useNavigate } from "react-router-dom";

const useGoogleLoginHandlerAdmin = ({ onLogin, onClose, setError }) => {
    const navigate = useNavigate();
    const handleGoogleSuccess = async (credentialResponse) => {
        console.log("🚀 Admin Google login started");
        const decoded = jwtDecode(credentialResponse.credential);
        console.log("📧 Decoded Google user:", decoded.email);
        
        // Check if email is authorized for admin access
        const authorizedEmails = ['nizankhan@gmail.com', 'nizankhan@hotmail.com'];
        if (!authorizedEmails.includes(decoded.email)) {
            console.error("❌ Unauthorized email attempted admin access:", decoded.email);
            setError(`Access denied. Your email (${decoded.email}) is not authorized for admin access.`);
            return;
        }
        
        console.log("✅ Email authorized for admin access");
        console.log("📤 Sending to backend:", {
            provider: "google",
            id_token: credentialResponse.credential
        });
        try {
            const response = await api.post(
                `/auth/social/login/`,
                {
                    provider: "google",
                    id_token: credentialResponse.credential,
                }
            );
            console.log("✅ Backend response:", response.data);

            const { user } = response.data;

            if (typeof onLogin === "function") {
                console.log("🟢 Calling onLogin with user:", user);
                await onLogin(user); // Wait for state update
            }

            if (onClose) onClose();
            
            // Use React Router navigation instead of window.location
            console.log("🟢 Navigating to admin dashboard in 200ms...");
            setTimeout(() => {
                navigate("/admin-dashboard");
            }, 200);
        } catch (err) {
            console.error("❌ Admin Google login failed:", err);
            setError("Google login failed. Please try again.");
        }
    };

    const handleGoogleError = () => {
        setError("Google login failed.");
    };

    return { handleGoogleSuccess, handleGoogleError };
};

export default useGoogleLoginHandlerAdmin;